<template>
  <wgu-module-card v-bind="$attrs"
      :moduleName="moduleName"
      class="wgu-helpwin"
      :icon="icon"
      :width="width"
      max-height="70%"
      max-width="90%"
    >
    <v-card-title primary-title>
      <div lang="de">
        <p style="font-family: 'Open Sans'" class="text-h5 mb-0 wgu-helpwin-wrap " v-if="$t('wgu-helpwin.textTitle')">
          {{ $t('wgu-helpwin.textTitle') }}</p>
      </div>
    </v-card-title>
    <v-card-text>
      <div class="text--primary wgu-helpwin-wrap" v-html="$t('wgu-helpwin.htmlContent')">
      </div>
    </v-card-text>

    <v-card-actions>
      <a class="info-link"
        :href="$t('wgu-helpwin.infoLinkUrl')" target="_blank" v-if="$t('wgu-helpwin.infoLinkUrl')">
        {{ $t('wgu-helpwin.infoLinkText') || $t('wgu-helpwin.infoLinkUrl') }}
        </a>
    </v-card-actions>
  </wgu-module-card>
</template>

<script>
import ModuleCard from '../modulecore/ModuleCard';

export default {
  name: 'wgu-helpwin-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard
  },
  props: {
    icon: { type: String, required: false, default: 'md:help' },
    width: { type: String, required: false, default: '30%' }
  },
  data () {
    return {
      moduleName: 'wgu-helpwin'
    }
  }
};
</script>

<style scoped>

  /* TODO
    Generalize the positioning concept for windows,
    this interferes with positioning and draggable settings in the app.conf */
  .wgu-helpwin.wgu-floating {
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
  }

  body.v-navigation-drawer--close .wgu-helpwin.wgu-floating {
    left: 80% !important;
    transform: translate(50%, -50%) !important;
  }

</style>
